/* global window */

import $ from "jquery";

$(() => {
  $(".c-start-browsing__form-container").on("submit", e => {
    const v = $(".c-start-browsing__search-box").val();
    window.location = `/explore-the-archive/search#q='${v}'`;
    e.preventDefault();
  });
});




// WEBPACK FOOTER //
// ./src/frontend/pages/explore-the-archive/freetext-search.js